import React, { useMemo, useState } from 'react'
import '../productos.css'; 
import Navbar from '../components/Navbar';
import Producto from '../components/Producto';
import contents from '../catalogo/singlets.js'
import Footer from '../components/Footer'


 
const Singlets = () => {
    // array de marcas seleccionadas. [] => todas
  const [selectedBrands, setSelectedBrands] = useState([]);

  // marcas únicas que existen en la lista
  const brands = useMemo(() => {
    const unique = Array.from(new Set(contents.map(p => p.brand).filter(Boolean)));
    unique.sort();
    return unique;
  }, []);

  const toggleBrand = (brand) => {
    setSelectedBrands((prev) =>
      prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]
    );
  };


  const filtered = useMemo(() => {
    if (selectedBrands.length === 0) return contents;
    return contents.filter((p) => selectedBrands.includes(p.brand));
  }, [selectedBrands]);


  return (
    <>
    <Navbar/>
    <div className='productos-Wrapper'>
      <div className='nombre-container'>
        <h2 className='nombre-pagina'>SINGLETS</h2>
                <div className="filters-bar">
          <div className="filters-row">
            <span className="filters-count">
              Mostrando {filtered.length} productos
            </span>

            <button className="filters-clear" type="button" onClick={() => setSelectedBrands([])}>
              Ver todas
            </button>
          </div>

          <div className="filters-checks">
            {brands.map((b) => (
              <label key={b} className="brand-check">
                <input
                  type="checkbox"
                  checked={selectedBrands.includes(b)}
                  onChange={() => toggleBrand(b)}
                />
                <span>{b}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
        <div className='productos-container'>
          {filtered.map((p) => {
            const firstVariant = p.variants?.[0];

            const image = firstVariant?.image || p.image;
            const price = firstVariant?.price || p.price;

            return (
              <Producto
                key={p.id}
                image={image}
                name={p.name}
                price={price}
                oldPrice={firstVariant?.oldPrice || p.oldPrice}
                slug={p.slug}
                variants={p.variants}
              />
            );
          })}

        </div>
    </div>
    <Footer/>
    </>
  );
};
export default Singlets